import React from 'react';
import { Box } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useLocation, useNavigate } from 'react-router-dom';

import { useSelector } from 'ihp-bloom-redux/app/redux';

import { useTabs } from '../../../hooks/useTabs';
import GeneralInfo from './GeneralInfo';
import Conditions from './Conditions';
import StudyContributors from './StudyContributors';
import { getSortedTabs, LANG } from '../../../utils/configParseUtils';
import {
  MyProfilePageHeader,
  MyProfilePageWrapper,
  PageTitle,
  ProfileTab,
  ProfileTabs,
  StyledBackArrow,
  StyledGrid,
  TabPanel,
} from '../MyProfile/styles';

const ParticipantProfile = () => {
  const navigate = useNavigate();
  const theme = useTheme();
  const upSm = useMediaQuery(theme.breakpoints.up('sm'));
  const { state } = useLocation();
  const {
    participantProfileConfig: { participantProfile },
  } = useSelector((state) => state.configuration);
  const tab = state?.selectedTab ? state.selectedTab : 0;
  const { selectedTab, setSelectedTab } = useTabs(tab);
  const sortedTabs = getSortedTabs(participantProfile?.tabs);

  const handleChange = (_, newSelectedTab) => {
    setSelectedTab(newSelectedTab);
  };

  const renderTabPanel = () => {
    return sortedTabs?.map((tab, index) => {
      return (
        <React.Fragment>
          {tab?.meta?.label?.[LANG] === 'General Info' && (
            <TabPanel value={selectedTab} index={index}>
              <GeneralInfo />
            </TabPanel>
          )}
          {tab?.meta?.label?.[LANG] === 'Conditions' && (
            <TabPanel value={selectedTab} index={index}>
              <Conditions />
            </TabPanel>
          )}
          {tab?.meta?.label?.[LANG] === 'Study Contributors' && (
            <TabPanel value={selectedTab} index={index}>
              <StudyContributors />
            </TabPanel>
          )}
        </React.Fragment>
      );
    });
  };

  const navigateToProfile = () => navigate('/profile');

  return (
    <MyProfilePageWrapper>
      <MyProfilePageHeader onClick={upSm ? null : navigateToProfile}>
        <StyledBackArrow />
        <PageTitle variant='h2'>Participant Profile</PageTitle>
      </MyProfilePageHeader>
      <Box display={'flex'} flexDirection={'column'} overflow={'auto'}>
        <Box>
          <ProfileTabs
            value={selectedTab}
            onChange={handleChange}
            aria-label='Profile tabs'
          >
            {sortedTabs?.map((tab, index) => {
              return (
                <ProfileTab label={tab?.meta?.label?.[LANG]} value={index} />
              );
            })}
          </ProfileTabs>
        </Box>
        <StyledGrid>{renderTabPanel()}</StyledGrid>
      </Box>
    </MyProfilePageWrapper>
  );
};

export default ParticipantProfile;
